/* eslint-disable camelcase */
import React, { useState } from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem } from "@mui/material"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { api, showSuccess, showWarning } from "../../../api"

const ModalTipoProceso = ({ open, onClose, data }) => {
  const queryClient = useQueryClient()
  const [form, setForm] = useState(data || { pro_nombre: "", pro_origen_erp: "", pro_estado: "A" })

  const { mutateAsync: saveProceso, isPending } = useMutation({
    mutationFn: async () => await api.post("/CRM_Carpetas/saveConfigTipoProceso", form),
    onSuccess: (res) => {
      showSuccess(res.data?.data || "Guardado correctamente.")
      queryClient.invalidateQueries(["getConfigTiposProceso"])
      onClose()
    },
    onError: (err) => showWarning(err.response?.data?.message || "Error al guardar."),
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{data ? "Editar Proceso" : "Nuevo Proceso"}</DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          label="Nombre del Proceso"
          margin="dense"
          value={form.pro_nombre}
          onChange={(e) => setForm({ ...form, pro_nombre: e.target.value })}
        />
        <TextField
          fullWidth
          label="Origen ERP (Ej: OPE, R, E)"
          margin="dense"
          value={form.pro_origen_erp}
          onChange={(e) => setForm({ ...form, pro_origen_erp: e.target.value })}
        />
        <TextField
          select
          fullWidth
          label="Estado"
          margin="dense"
          value={form.pro_estado}
          onChange={(e) => setForm({ ...form, pro_estado: e.target.value })}
        >
          <MenuItem value="A">ACTIVO</MenuItem>
          <MenuItem value="I">INACTIVO</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPending}>
          Cancelar
        </Button>
        <Button onClick={() => saveProceso()} variant="contained" disabled={isPending}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalTipoProceso
